import { TypedNode } from "../_Base";
import { ThreeToGl } from "../../../core/ThreeToGl";
import { NodeContext } from "../../poly/NodeContext";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { ParamsEditableStateController } from "../utils/io/ParamsEditableStateController";
const REGEX_PATH_SANITIZE = /\/+/g;
export class TypedGlNode extends TypedNode {
  constructor() {
    super(...arguments);
    this._paramsEditableStatesController = new ParamsEditableStateController(this);
  }
  static context() {
    return NodeContext.GL;
  }
  initializeBaseNode() {
    this.uiData.setLayoutHorizontal();
    this.io.connections.initInputs();
    this.io.connection_points.spare_params.initializeNode();
    this._paramsEditableStatesController.initializeNode();
  }
  cook() {
    console.warn("gl node cooking");
  }
  _setMatToRecompile() {
    var _a, _b;
    (_b = (_a = this.materialNode()) == null ? void 0 : _a.assemblerController()) == null ? void 0 : _b.set_compilation_required_and_dirty(this);
  }
  materialNode() {
    const parent = this.parent();
    if (parent) {
      if (parent.context() == NodeContext.GL) {
        return parent == null ? void 0 : parent.materialNode();
      } else {
        return parent;
      }
    }
  }
  glVarName(name) {
    const path_sanitized = this.path(this.materialNode()).replace(REGEX_PATH_SANITIZE, "_");
    return `v_POLY_${path_sanitized}_${name}`;
  }
  variableForInputParam(param) {
    return this.variableForInput(param.name());
  }
  variableForInput(inputName) {
    var _a;
    const input_index = this.io.inputs.getInputIndex(inputName);
    const connection = this.io.connections.inputConnection(input_index);
    if (connection) {
      const input_node = connection.node_src;
      const output_connection_point = input_node.io.outputs.namedOutputConnectionPoints()[connection.output_index];
      if (output_connection_point) {
        const output_name = output_connection_point.name();
        return input_node.glVarName(output_name);
      } else {
        console.warn(`no output called '${inputName}' for gl node ${input_node.path()}`);
        throw "variable_for_input ERROR";
      }
    } else {
      if (this.params.has(inputName)) {
        return ThreeToGl.any((_a = this.params.get(inputName)) == null ? void 0 : _a.value);
      } else {
        const connection_point = this.io.inputs.namedInputConnectionPoints()[input_index];
        return ThreeToGl.any(connection_point.init_value);
      }
    }
  }
  setLines(shaders_collection_controller) {
  }
  reset_code() {
    var _a;
    (_a = this._param_configs_controller) == null ? void 0 : _a.reset();
  }
  setParamConfigs() {
  }
  param_configs() {
    var _a;
    return (_a = this._param_configs_controller) == null ? void 0 : _a.list();
  }
  paramsGenerating() {
    return false;
  }
  paramDefaultValue(name) {
    return null;
  }
}
export class BaseGlNodeClass extends TypedGlNode {
}
class ParamlessGlParamsConfig extends NodeParamsConfig {
}
const ParamsConfig = new ParamlessGlParamsConfig();
export class ParamlessTypedGlNode extends TypedGlNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
}
